export const sx = {
    root: {
        padding: {
            xs:'3px',
            lg:'0 10px',
        },
        minHeight: '150px',
        transition: 'all .3s',
        height: '100%',
        overflowX: 'hidden,',
        '&.disabled': {
            opacity: '.5',
            pointerEvents: 'none'
        },
    },
    inner: {
        position: 'relative',
        width: '100%',
        gap:'5px'
    },
    wrap:{
        padding:'6px 0 3px',
        width:'100%',
        height: '100%',
        gap:'7px'
    }
}